import { Value } from "@common/ADAPT.Common.Model/organisation/value";
import { StringUtilities } from "@common/lib/utilities/string-utilities";

export class ValuesConstitutionUtilities {

    public static generateValueId(value: Value) {
        return StringUtilities.stripSpace(value.name);
    }
}
